<template>
    <div class="layout-container table-special">
        <el-tabs type="border-card">
            <el-tab-pane label="用户黑名单">
                <div style="background: #ffffff;position:relative;">
                    <div class="search-condition-con" :class="'show'">
                        <div class="search-condition">
                            <span class="label">手机号</span>
                            <div class="input-condition">
                                <el-input v-model="condition.mobile" placeholder="请输入手机号查询"></el-input>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label">站点</span>
                            <div class="input-condition">
                                <site-auto-complete v-model="condition.site_id" :clueId=1 :init-choose-first="false" :owned='true' :dataType=1 ref="siteAutoComplete"  @created="initData" clearable></site-auto-complete>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label">原因</span>
                            <div class="input-condition">
                                <el-input v-model="condition.remark" placeholder="输入原因关键词查询"></el-input>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label">来源</span>
                            <div class="input-condition">
                                <el-select v-model="condition.source_id" filterable placeholder="请选择">
                                    <el-option
                                    v-for="item in sourceList"
                                    :key="item.id"
                                    :label="item.value"
                                    :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label">添加人</span>
                            <div class="input-condition">
                                <el-input v-model="condition.creator" placeholder="添加人名称"></el-input>
                            </div>
                        </div>
                        <div class="search-condition search-condition-time" style="min-width: 400px;">
                            <span class="label">添加时间</span>
                            <div class="input-condition">
                                <el-date-picker
                                        v-model="addtime"
                                        type="datetimerange"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期"
                                        align="right"
                                        value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm"
                                        @change="changeDate"
                                >
                                </el-date-picker>
                            </div>
                        </div>
                        <div class="">
                            <el-button type="primary" @click="handleSearch()">查 询</el-button>
                            <el-button  @click="resetSearch()">清空条件</el-button>
                        </div>

                    </div>
                    <div class="btn-condition">
                        <el-button
                        type="primary"
                        @click="handleAdd()"
                        >添加用户黑名单</el-button>
                    </div>
                </div>
                <el-table
                    :data="list"
                    style="width: 100%"
                    :highlight-current-row="true"
                    :border="true"
                    tooltip-effect="dark"
                    ref="multipleTable"
                    v-loading="isLoading"
                    header-cell-class-name="table-back"
                    class="list-table"
                    >
                        <el-table-column  label="手机号" prop="mobile" align="center"></el-table-column>
                        <el-table-column  label="限制站点" prop="site_arr" align="center">
                            <template slot-scope="scope">
                                <el-tooltip popper-class="tooltip" effect="dark" :content="scope.row.site_arr.join(',')" placement="top">
                                    <span class="ellipse4">{{scope.row.site_arr.join(',')}}</span>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column  label="拉黑原因" prop="remark" align="center">
                            <template slot-scope="scope">
                                <el-tooltip popper-class="tooltip" effect="dark" :content="scope.row.remark" placement="top">
                                    <span class="ellipse4">{{scope.row.remark}}</span>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column  label="来源" prop="source_name" align="center"></el-table-column>
                        <el-table-column  label="添加人" prop="creator" align="center"></el-table-column>
                        <el-table-column  label="添加时间" prop="created_at" align="center"></el-table-column>
                        <el-table-column label="操作" width="300px" align="center">
                            <template slot-scope="scope">
                                <el-button  type="text" size="mini" @click="openEdit(scope.row)"
                                    >编辑</el-button>
                                <el-button  type="text" size="mini" @click="handleDelet(scope.row.id)"
                                    >移除</el-button>
                            </template>
                        </el-table-column>
                </el-table>
                <template v-if="list.length > 0">
                    <el-pagination
                        background
                        layout="total,prev, pager, next"
                        :current-page="condition.page"
                        :total="condition.total"
                        :page-size="condition.per_page"
                        @current-change="currentChange"
                    ></el-pagination>
                </template>
                <add-user-black ref="backAddRef" :callback="initData" />
                <edit-user-black ref="backEditRef" :callback="initData" />
            </el-tab-pane>
        </el-tabs>  
    </div>
</template>
<style>
    td a:link{
        color: #606266;
    }
    td a:visited{
        color: #606266;
    }
</style>
<script>
    import {getUserBlacklist,deleteUserBlack} from '@/service/blackModel'
    import SiteAutoComplete from "@/components/auto-complete/site-auto-complete";
    import { getSite } from "@/service/site";
    import addUserBlack from './component/addUserBlack';
    import editUserBlack from './component/editUserBlack';
    export default {
        name: "List",
        components:{
            SiteAutoComplete,
            addUserBlack,
            editUserBlack
        },
        data () {
            return {
                list:[],
                condition:{
                    site_id:"",
                    mobile: '',
                    source_id: '',
                    remark: '',
                    creator:"",
                    start_time:"",
                    end_time:"",
                    total: 0,
                    per_page:10,
                    page:1,
                },
                sourceList:[{
                    id:"1",
                    value:"后台添加",
                },{
                    id:"2",
                    value:"好房云同步",
                }],
                isLoading:false,
                siteAll:[],
                asksInfo:{},
                addtime:null,
            }
        },
        mounted () {
            this.initData();
            this.getSiteList();
        },
        methods: {
            async getSiteList() {
                await getSite({ owned:1, agent_status: 0, per_page: 1000 }).then((data) => {
                    this.siteAll = data.data;
                });
              
            },
            async initData(){
                this.isLoading = true;
                getUserBlacklist(this.condition).then(res => {
                    this.condition.total=res.total
                    this.list = res.data
                })
                this.isLoading = false;
            },
            currentChange(index) {
                this.condition.page = index;
                this.initData();
            },
            handleSearch(){
                this.initData()
            },
            resetSearch(){
                this.condition={
                    site_id:"",
                    mobile: '',
                    source_id: '',
                    remark: '',
                    creator:"",
                    start_time:"",
                    end_time:"",
                    total: 0,
                    per_page:10,
                    page:1,
                }
                this.addtime = null;
                this.initData();
            },
            handleAdd(){
                this.$refs.backAddRef && 
                (this.$refs.backAddRef.siteList = this.siteAll)
                this.$refs.backAddRef.openMenu()
            },
            openEdit(row){
                this.$refs.backEditRef && 
                (this.$refs.backEditRef.siteList = this.siteAll)
                this.$refs.backEditRef.openMenu(row.id)
            },
            changeDate(){
                this.condition.start_time = Date.parse(this.addtime[0])/1000;
                this.condition.end_time = Date.parse(this.addtime[1])/1000;
            },
            handleDelet(id){
                this.$confirm("是否确定将此手机号从黑名单列表中移除，移除后可将可正常进行表单报名和IM咨询", "操作提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    deleteUserBlack(id)
                    .then(() => {
                        this.$message({
                        type: "success",
                        message: "删除成功"
                        });
                        this.initData();
                    })
                    .catch(err => {
                        this.$message({
                        type: "error",
                        message: err.message || "删除失败"
                        });
                    });
                });
            }
        }
    }
</script>
<style>
    .tooltip{
        max-width: 400px;
    }
</style>
<style scoped>
.ellipse4 {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    overflow: hidden;
}
</style>



















